import { FC, useMemo } from 'react';
import { LayoutCarousel, ProgressPolygonList } from '@silverfort/sf-components';
import { LocalAccountsInsights } from '../../../types/LocalAccountsInsights';

interface Props {
    localAccountsInsights?: LocalAccountsInsights;
    isLoading: boolean;
}

const toProgressItem = (label: string, count: number, total: number) => {
    const progress = Math.floor((count / (total || 1)) * 100);

    return {
        label,
        value: count,
        progress,
        tooltipContent: `${label} Local Accounts: ${count}`,
        startColor: '#FFAF39',
        endColor: '#FFEACB'
    }; 
}

const LocalAccountsModeStatisticsCard: FC<Props> = ({ localAccountsInsights, isLoading }) => {
    const pages = useMemo(() => {
        const isNoLocalAccounts = !localAccountsInsights?.totalLocalAccounts;
        const localAccountsModes = isNoLocalAccounts ? [
            toProgressItem('Enabled', 0, 0),
            toProgressItem('Disabled', 0, 0)
        ] : [
            toProgressItem('Enabled', localAccountsInsights.enabledLocalAccounts, localAccountsInsights.totalLocalAccounts),
            toProgressItem('Disabled', localAccountsInsights.disabledLocalAccounts, localAccountsInsights.totalLocalAccounts)
        ];
        const pagesArray = [
            <div className="flex flex-1 flex-row items-center w-full">
                <div className="flex-1">
                    <ProgressPolygonList items={localAccountsModes} isLoading={isLoading} />
                </div>
            </div>
        ];

        return pagesArray;
    }, [localAccountsInsights, isLoading]);

    return (
        <LayoutCarousel
            title="Status"
            contentClassName="flex flex-1 flex-col justify-center px-6"
            pages={pages}
        />
    );
};

export default LocalAccountsModeStatisticsCard;
